import React, { useState, useEffect } from "react";
import { getImageUrl } from "../imageUrl";

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  //   useEffect(() => {
  //     const interval = setInterval(() => {
  //       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  //     }, 3000); // Change image every 3 seconds

  //     return () => clearInterval(interval);
  //   }, [images?.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };
  console.log("images", images);
  return (
    <div className="slider">
      <div className="slider-images">
        {images?.map((image, index) => (
          <img
            key={index}
            src={getImageUrl(image.image)}
            alt={`Slide ${index}`}
            className={index === currentIndex ? "active" : ""}
          />
        ))}
      </div>
      <div className="slider-dots">
        {images?.map((_, index) => (
          <span
            key={index}
            className={index === currentIndex ? "dot active" : "dot"}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
